import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'business-list.list-view.priority-cell.error-title',
		defaultMessage: "We couldn't save the issue priority.",
		description: 'Error message informing the user that updating the field failed',
	},
	errorMessage: {
		id: 'business-list.list-view.priority-cell.error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when save fails',
	},
	placeholder: {
		id: 'business-list.list-view.priority-cell.placeholder',
		defaultMessage: 'Select Priority',
		description: 'Priority picker placeholder text.',
	},
	priorityLabel: {
		id: 'business-list.list-view.priority-cell.priority-label',
		defaultMessage: '{priority} priority',
		description: 'Alt text for different priority images. e.g High priority or Low priority.',
	},
	errorTitleIssueTermRefresh: {
		id: 'business-list.list-view.priority-cell.error-title-issue-term-refresh',
		defaultMessage: "We couldn't save the work item priority ",
		description: 'Error message informing the user that updating the field failed',
	},
});
